module.exports = __webpack_public_path__ + "img/lg_ring_y_e_0_0@3x.827b7f32.png";